/**
 * HubSpot Request Quote form configuration
 *
 * Centralized credentials for the V4 developer embed and the public Forms API
 * fallback. Same portal + form is used across all design tools (CRD/CD/WD)
 * and across both submission paths — having two sources of truth split
 * submissions between forms in HubSpot CRM if one is updated and the other
 * isn't.
 *
 * NOTE: the script URL in `public/index.html` ALSO contains the portal ID
 * (`https://js-na2.hsforms.net/forms/embed/developer/${HUBSPOT_PORTAL_ID}.js`)
 * — HTML can't import these constants, so that URL must be updated manually
 * if the portal changes.
 */

export const HUBSPOT_PORTAL_ID = '45958592';
export const HUBSPOT_FORM_ID = 'c431cede-783c-4e8f-92a7-2cab2640a368';
export const HUBSPOT_REGION = 'na2';
